import { NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { RtUIDialogModule } from '../dialog/dialog.module';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';
import { DialogService } from './dialogs.service';
import { ProtectedControlsDialogComponent } from './protected-controls-dialog/protected-controls-dialog.component';
import { ProtectedControlsDialogModule } from './protected-controls-dialog/protected-controls-dialog.module';

@NgModule({
  imports: [RtUICommonModule, RtUIDialogModule, ProtectedControlsDialogModule, ConfirmDialogModule],
  exports: [ProtectedControlsDialogModule, ConfirmDialogModule],
})
export class RtUIDialogsModule {}
export { DialogService };
export { DialogConfirmOptions, DialogConfirmVariant } from './dialogs.service';
export { ConfirmDialogVariant } from './dialogs.types';
export { ProtectedControlsDialogComponent };
